import { render, staticRenderFns } from "./Breadcrum.vue?vue&type=template&id=150d2dfd&scoped=true"
import script from "./Breadcrum.vue?vue&type=script&lang=js"
export * from "./Breadcrum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d2dfd",
  null
  
)

export default component.exports